import React from 'react';
import Switch from 'react-switch';
import styled, { css } from 'styled-components';
import { Icon } from 'antd';

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: 30px;
  text-align: center;
  justify-content: center;
  transition: 0.3s color ease;

  ${({ selected }) =>
    selected
      ? css`
        color: #bfbfbf !important;
        `
      : css`
        color: #ffffff !important;
        `}
`;

export const MailIcon = ({ selected }) => (
  <IconContainer selected={selected}>
    <Icon type="mail" />
  </IconContainer>
);

export const PhoneIcon = ({ selected }) => (
  <IconContainer selected={selected}>
    <Icon type="phone" />
  </IconContainer>
);

export const StyledSwitch = styled(Switch)`

  margin: 5px 16px 0px 5px;

  .react-switch-handle {
    background: #ffffff !important;
    height: 30px !important;
    width: 30px !important;
    outline: none;
  }

  .react-switch-bg {
    background: #ccc !important;
    border: 1px solid #bfbfbf;
    border-radius: 15px !important;
    height: 32px !important;
    width: 60px !important;
  }

  .react-switch-bg > div {
    height: 30px !important;
    justify-content: center;
    opacity: 1 !important;
    outline: none;
    width: 30px !important;
    z-index: 1;
  }

  .react-switch-bg > div:not(:first-child) {
    width: 30px !important;
  }
`;

export default { MailIcon, PhoneIcon };



// WEBPACK FOOTER //
// ./src/components/SwitchContactType/styles.js